interface Props {
  fill?: string,
  width?: string | number,
  height?: string | number,
  className: string,
}

const InComplete = ({
  fill = '#ee6d5d',
  width = '46',
  height = '46',
  className,
}: Props) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 46 46"
    className={className}
  >
    <path
      fill={fill}
      fillRule="evenodd"
      d="M 22.99 45.98 C 10.31 45.98 0 35.66 0 22.98 C 0 10.31 10.31 -0.01 22.99 -0.01 C 35.67 -0.01 45.98 10.31 45.98 22.98 C 45.98 35.66 35.67 45.98 22.99 45.98 Z M 22.99 2.27 C 11.57 2.27 2.27 11.56 2.27 22.98 C 2.27 34.41 11.57 43.7 22.99 43.7 C 34.41 43.7 43.71 34.41 43.71 22.98 C 43.71 11.56 34.41 2.27 22.99 2.27 Z M 22.98 34.03 C 22.04 34.03 21.28 33.27 21.28 32.32 C 21.28 31.38 22.04 30.62 22.98 30.62 C 23.92 30.62 24.69 31.38 24.69 32.32 C 24.69 33.27 23.92 34.03 22.98 34.03 Z M 22.98 27.94 C 22.36 27.94 21.85 27.43 21.85 26.8 C 21.85 26.8 21.85 13.46 21.85 13.46 C 21.85 12.83 22.36 12.32 22.98 12.32 C 23.61 12.32 24.12 12.83 24.12 13.46 C 24.12 13.46 24.12 26.8 24.12 26.8 C 24.12 27.43 23.61 27.94 22.98 27.94 Z"
    />
  </svg>
);

export default InComplete;
